import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/BackButton.css';

interface BackButtonProps {
  to?: string;
  label?: string;
  className?: string;
  showIcon?: boolean;
}

function BackButton({ 
  to, 
  label = "العودة", 
  className = "", 
  showIcon = true 
}: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <motion.button
      className={`back-button ${className}`}
      onClick={handleClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
    >
      {showIcon && <span className="back-icon">←</span>}
      <span className="back-text">{label}</span>
    </motion.button>
  );
}

export default BackButton;